import { DemoName } from 'app/demos/demo-name';

export class DemoAccess {
    constructor(public name: DemoName, public roles: string[] = []) {
    }
}
